import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { HttpInterceptorFn, provideHttpClient, withInterceptors } from '@angular/common/http';

import { ApplicationType } from '@kros-sk/models';

import { APPLICATION_TYPE_CONFIG } from './kros-auth.config';
import { authServiceInitializationFactory } from './kros-auth.module';
import { configClientId, configScope } from './injection-tokens';
import { getAuthInterceptorFn, InterceptUrlPredicate } from './interceptor-fns/kros-auth-interceptor-fn';
import { KROS_IDENTITY_SERVER_CONFIG, KrosIdentityServerConfig } from './services/auth/kros-identity-server.config';
import { KrosAuthGuardService } from './guards/kros-auth-guard.service';
import { KrosAuthService } from './services/auth/kros-auth.service';
import { provideAuthStore } from './store/auth-store.provider';

export function provideInterceptedHttpClient(
  authInterceptorUrlFilter: InterceptUrlPredicate,
  otherInterceptors: HttpInterceptorFn[] = []
): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideHttpClient(withInterceptors([getAuthInterceptorFn(authInterceptorUrlFilter), ...otherInterceptors])),
  ]);
}

export function provideApiConfigAndAuth(
  identityServerConfig: KrosIdentityServerConfig,
  clientId: string,
  scope: string,
  applicationType: ApplicationType
): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAuthStore(),
    KrosAuthService,
    KrosAuthGuardService,
    {
      provide: KROS_IDENTITY_SERVER_CONFIG,
      useValue: identityServerConfig,
    },
    {
      provide: APPLICATION_TYPE_CONFIG,
      useValue: applicationType,
    },
    {
      provide: configClientId,
      useValue: clientId,
    },
    {
      provide: configScope,
      useValue: scope,
    },
    provideAppInitializer(() => {
      const initializerFn = authServiceInitializationFactory(
        inject(KrosAuthService),
        inject(configClientId),
        inject(configScope),
        inject(APPLICATION_TYPE_CONFIG)
      );
      return initializerFn();
    }),
  ]);
}
